import { render, staticRenderFns } from "./RadarHelp.vue?vue&type=template&id=12d22b47&scoped=true"
import script from "./RadarHelp.vue?vue&type=script&lang=js"
export * from "./RadarHelp.vue?vue&type=script&lang=js"
import style0 from "./RadarHelp.vue?vue&type=style&index=0&id=12d22b47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d22b47",
  null
  
)

export default component.exports